<template>
  <el-dialog
    :title="Title"
    :visible="YenilikModal"
    center
    width="50%">
    <a @click="$emit('YenilikModal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <div v-html="Data[0].Icerik">
    </div>
    <!--el-collapse v-model="activeNames">
      <el-collapse-item v-for="d in Data" :title="d.Baslik" :name="d.Sira">
        <div v-html="d.Icerik">
        </div>
      </el-collapse-item>
    </el-collapse-->
    <Yukleniyor :data="lo"></Yukleniyor>
  </el-dialog>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ['YenilikModal'],
    data() {
      return {
        Title: 'Yenilikler',
        activeNames: [1],
        Data: null,
        lo: false
      }
    },
    created() {

      this.lo = true;
      this.$store.dispatch("Get", {path: 'kilavuz/yenilikler/'})
        .then(response => {
          this.lo = false;
          this.Data = response.Data;
          this.Title = this.Data[0].Baslik
        });

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/Yenilikler.vue